import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchEmploymentTypes = createAsyncThunk("fetchEmploymentTypes", async () => {
	const response = await axiosHttp.get(`employee/employmenttypes`);
	return response.data.data;
});

const employmentTypeSlice = createSlice({
	name: "employmentTypeSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchEmploymentTypes.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchEmploymentTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchEmploymentTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default employmentTypeSlice.reducer;
